import { Component, OnInit, Input } from '@angular/core';
import { Locale } from '../../../../shared/model/locale.model';
import { Product } from '../../../../shared/model/product.model';
import { FormGroup } from '@angular/forms';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-product-com-ui',
  templateUrl: './product-com-ui.component.html',
  styleUrls: ['./product-com-ui.component.scss', '../../../../shared/shared.styles.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ProductComUiComponent implements OnInit {
  @Input() mode: string;
  @Input() locale: Locale;
  @Input() product: Product;
  @Input() frm: FormGroup;

  constructor() {
    console.log('ProductComUiComponent.constructor()');
  }

  ngOnInit(): void {
    console.log('ProductComUiComponent.ngOnInit()');
    console.log('ProductComUiComponent', this.product);
  }

  get isEditMode() {
    return this.mode === 'edit';
  }

  get isCreateMode() {
    return this.mode === 'create';
  }

  get isViewMode() {
    return this.mode === 'view';
  }
}
